import { useWpLayout } from '@pets-ui/useWpLayout/useWpLayout'
import { jwtDecode } from 'jwt-decode'
import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import { useRequestUser } from '../../../hooks/apis/wp/useRequestUser'
import { type Country } from '../../../types/dataModel/platformSdk'
import { getXPlatformToken } from '../../../utils/cookie'
import { wordPressNavigate } from '../../../utils/wordPressRoute'
import { useContextCosign } from '../../useContextCosign'
import { CardLogin } from '../CardLogin'
import { BindStep } from '../login/types'
import { Service } from '../Service'
import { BindPhone } from './BindPhone'
import { BindPhoneValidation } from './BindPhoneValidation'

export function BindPhonePortal() {
  const { t } = useTranslation()
  const { title } = useContextCosign()
  const { destructuredData: user } = useRequestUser(undefined, { shouldRetryOnError: false })
  const xPlatformToken = getXPlatformToken()
  const decoded = xPlatformToken ? jwtDecode<{ platformUid?: string }>(xPlatformToken) : null

  const [step, setStep] = useState(BindStep.INPUT_ACCOUNT)
  const [phone, setPhone] = useState('')
  const [phoneError, setPhoneError] = useState('')

  const [countryCode, setCountryCode] = useState<Country['countryIsoCode']>()
  useWpLayout({ footer: false })

  useEffect(() => {
    if (user?.platformUserProfile.phone) wordPressNavigate('/my-account/edit-account/')
    if (!decoded?.platformUid) wordPressNavigate('/my-account/')
  }, [decoded?.platformUid, user?.platformUserProfile.phone])

  return (
    <CardLogin>
      <Helmet>
        <title>
          {t('login.verifyIdentity')}
          {' '}
          -
          {' '}
          {title}
        </title>
      </Helmet>
      {step === BindStep.INPUT_ACCOUNT
      && (
        <BindPhone
          phone={phone}
          setPhone={setPhone}
          phoneError={phoneError}
          setPhoneError={setPhoneError}
          setStep={setStep}
          countryCode={countryCode}
          setCountryCode={setCountryCode}
        />
      )}
      {step === BindStep.VALIDATE
      && (
        <BindPhoneValidation
          phone={phone}
          setStep={setStep}
          countryCode={countryCode}
        />
      )}
      <Service />
    </CardLogin>
  )
}
